import type { ReactNode } from "react";
import { Badge, type CaseStatus } from "@dearbill/shared";
import { CASE_STATUS_CHIP_CLASS, CASE_STATUS_TONE } from "./caseStatus";

/**
 * The case status as a shared `Badge` labelled with the status text. The tone
 * supplies the pill's icon; the surface and text come from the per-status
 * class map, so New and Closed stay visually distinct. The color never carries
 * meaning by itself, because the label is always present.
 */
export function CaseStatusLabel({ status }: { status: CaseStatus }): ReactNode {
  return (
    <Badge tone={CASE_STATUS_TONE[status]} className={CASE_STATUS_CHIP_CLASS[status]}>
      {status}
    </Badge>
  );
}
